import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSelfUser, getShops } from "../../../../../services/auth/actions";
import Status from "../../dashboard/status";
import { useHistory } from "react-router";
import { Button } from "components";
import useMobile from "../../../../../hooks/useMobile";

import "./style.scss";

const CloseIcon = () => <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.5 4.5L4.5 13.5" stroke="var(--black9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4.5 4.5L13.5 13.5" stroke="var(--black9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>;

const Close = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 6L6 18" stroke="var(--black9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6 6L18 18" stroke="var(--black9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>;


const Header = () => {

    const history = useHistory();
    const dispatch = useDispatch();
    const isAuth = useSelector(({ auth }) => auth.isAuth);

    useEffect(() => {
        let isAdmin = window.location.origin.includes('admin');

        if (!isAuth) {
            dispatch(getSelfUser())
                .then(({status, data}) => {
                    if (status === 200) {
                        dispatch(getShops(data.user.username));

                        if (isAdmin && +data.user.rank < 1) {
                            history.push(`/home`);
                        }
                    }
                });
        }
    }, []);

    const isMobile = useMobile();

    return <>
        <Status />

        <div className="theme-store-header-container">
            <div className="theme-store-header">
                {isMobile ? <div onClick={() => history.push('/customization/themes')} className="theme-store-header-close"><Close /></div> : null}
                <div className="theme-store-header-logo" style={{ color: "var(--black9)" }}>Theme Store</div>

                <div className="theme-store-header-buttons">
                  <div className="theme-store-header-menu d-flex" style={{gap: ".75rem"}}>
                    {isMobile ? null : <Button size="large" variant="secondary" onClick={() => history.push('/customization/themes')}><CloseIcon/></Button>}
                  </div>
                </div>
            </div>
        </div>
    </>
};

export default Header;
